import styled from 'styled-components';

export const AppHeaderWrapper: any = styled.div`

    .header {
        width: 100%;     
        position: fixed;
        z-index: 1040;
        min-height: 50px;
    }
    .header header{
        background-color: #0099FF;
        min-height: 50px;
        box-shadow: none;
    }
    header .headerToolbar{
        min-height: 50px;
    }
    header .headerTitle{
        font-size: 18px;
        font-weight: bold;
    }
    .grow {
        flex-grow: 1;
    }

    .offlineAlertMsg {
        color: #cc0000;
        background-color: #f8cbcb;
        border-color: #f8cbcb;
        padding: 7px 15px;       
        border: 1px solid transparent;
        border-radius: 4px;
        position: relative;
        left: 0%;
        top: 15%;       
        margin: 0 auto;
        font-size: 16px;
        text-align: center;
    }

    .sectionDesktop{
        display: flex;
    }

    .header .menuButton{
        padding: 13px 12px;
        background-color: #000;
        border-radius: 0px;
        margin-right: 15px;
    }
    .header .popperMenu{
        position: absolute;
        top: 50px;
        left: 0px;
        min-width: 20%;
        background-color: #000;
    }
    .popperMenu .appMenuList li{
        color: #fff;
        padding: 15px 30px;
    }
    .popperMenu .appMenuList li:hover{
        background-color: #ccc;
    }

    .popperNotificationMenu .appMenuList .unreadNotification{
        background-color: #ccc;
    }

    .header .popperNotificationMenu{
        position: absolute;
        top: 64px;
        // right: 2%;
        min-width: 20%;
        background-color: #000;
        min-width: 30%;
        max-height: 550px;
        overflow-y: scroll;
        max-width: 700px;
        right: 0px;
        white-space: normal;
    }
    .popperNotificationMenu .appMenuList{
        margin: 0px 0px;
    }
    .popperNotificationMenu .appMenuList li{
        color: #fff;
        padding: 15px 20px;
        border-top: 1px solid #aaa;
        cursor: default;
        height: auto;
    }
    .popperNotificationMenu .appMenuList li p{
        margin: 0px;
        white-space: normal;
    }
    .popperNotificationMenu .appMenuList li:first-child{
        border-top: 0px;
    }
    .popperNotificationMenu .appMenuList li:hover{
        background-color: #ccc;
        color: #000;
        font-weight: bold;
    }
    .popperNotificationMenu .appMenuList li .listNotifyIcon{
        margin-left: -20px;
        margin-right: 10px;
    }

    .popperUserAccount{
        background-color: #000;
        color: #fff;
        top: 5px !important;
    }
    .popperUserAccount .userMenuList li{
        color: #fff;
    }

    .notificationSection .notificationBadge .MuiBadge-badge-235{
        background-color: #cc0000;
    }
`;


// WEBPACK FOOTER //
// ./src/styles/header.tsx